let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gyANk")).then(() => parcelRequire('7eho6'));